import React from 'react'
import {Link} from 'react-router-dom'

export default function VOPContent({ children }) {
  return (
    <div className="simple-text-page">
      <div>
        <h1 className="h3 mt-2 mb-3">OBCHODNÍ PODMÍNKY</h1>
        <p className="text pb-3 bb-1">
          Všeobecné obchodní podmínky věrnostního programu Lobster Friends.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">VĚRNOSTNÍ PROGRAM</h5>
        <p className="text pb-3 bb-1">
          Věrnostní program Lobster Friends (v dále jen jako „program“) je pořádaný společností Gastroland restaurants s.r.o., se sídlem Olomouc,
          tř. Svobody 956/31 PSČ 779 00, IČO: 285 858 36, zapsané v obchodním rejstříku vedeném u Krajského soudu v Ostravě v oddíle C,
          vložce 44002 (dále jen „Gastroland“). Členství v programu je určeno fyzickým osobám starším 18 let;
          členem programu se nemůže stát právnická osoba nebo fyzická osoba - podnikatel.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">VÝHODY VĚRNOSTNÍHO PROGRAMU LOBSTER FRIENDS</h5>
        <p className="text pb-3 bb-1">
          Program je zaměřen na poskytování nadstandardních výhod pro stálé zákazníky Gastrolandu.
          <br/><br/>
          Členství v programu je zdarma a vzniká provedením registrace. Jako člen programu jste odměňován/a za všechny své nákupy realizované s použitím Vaší karty Lobster Friends bonusovými body, které se připisují na Váš účet vedený u
          provozovatele programu. Za každých 100 Kč zaplacených v restauracích provozovatele získáváte 1 000 bonusových bodů. Body se nezískávají za nákup dárkových poukazů, při uplatnění dárkového poukazu Vám je ale na účet připíšeme. Body nelze
          načíst za úhradu pronájmu bowlingové dráhy a za zakoupení kurzu vaření. <br/><br/>
          Získané bonusové body můžete následně kdykoliv uplatnit ve formě slevy při platbě a při předložení Vaší Lobster Friends karty za konzumaci v provozovnách provozovatele. Za každých připsaných 10 000 bodů obdržíte slevu ve výši 100 Kč.
          Během jednoho nákupu můžete uplatnit slevu za bonusové body až do výše 50 % celkové ceny nákupu.
          <br/><br/>
          Další výhody pro členy programu Lobster Friends, uplatnitelné pouze v Lobster Family Restaurant, jsou - tip šéfkuchaře za zvýhodněnou cenu, v den narozenin narozeninové jídlo s dezertem zdarma a 50% sleva na hodinu bowlingu každý měsíc
          (od pondělí do pátku).
          <br/><br/>
          Společnost Gastroland může pro členy programu vytvářet speciální akce a nabídky, o kterých Vás bude informovat prostřednictvím webových stránek programu, e-mailové komunikace a materiálů umístěných v restauracích.
          <br/><br/>
          Pokud není v podmínkách programu nebo nabídky provozovatele výslovně stanoveno jinak, slevy při uplatnění bonusových bodů a jiné slevy nebo výhody poskytované v rámci programu nebo věrnostní karty nelze sčítat ani je uplatnit současně s
          jinými slevami a výhodami nabízenými provozovatelem.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">ČLENSTVÍ VE VĚRNOSTNÍM PROGRAMU</h5>
        <p className="text pb-3 bb-1">
          Členem programu se může stát výlučně fyzická osoba starší 18 let. Podmínkou řádného členství je dokončení registrace prostřednictvím
          mobilní aplikace Lobsterka a vyplnění registračního formuláře v papírové formě v případě registrace do programu Lobster Friends.
          Během registrace Vás požádáme o poskytnutí osobních údajů, které budou použity pro komunikaci s Vámi.
          Vaše údaje můžeme využít pro ověření Vaší totožnosti v případě ztráty nebo zapomenutí karty a pro zasílání obchodních sdělení programu.
          Je nutné, aby Vaše údaje byly pravdivé a vždy aktuální.
          <br/><br/>
          Podmínkou řádné registrace je projevení vůle řídit se těmito podmínkami programu a udělení souhlasu se zpracováním a shromažďováním Vašich
          osobních údajů a s automatickým zpracováním osobních údajů.
          <br/><br/>
          Vaší povinností je chránit Vaše přihlašovací údaje a heslo před prozrazením třetí osobě. V případě podezření úniku přihlašovacích údajů máte povinnost si heslo změnit.
          <br/><br/>
          Věrnostní kartu programu Lobster Friends získáte po pěti návštěvách restaurací provozovatele. Jednotlivé návštěvy prokážete načtením
          čárových kódů z pěti různých účtenek z restaurací provozovatele programu prostřednictvím mobilní aplikace Lobsterka.
          Po načtení pěti návštěv Vám na vyžádání personál restaurace, po vyplnění papírového registračního formuláře, předá Vaši kartu Lobster Friends.
          Karta nepředstavuje elektonický platební prostředek, slouží pouze k evidenci počtu načtených bonusových bodů. Vaše Lobster Friends karta je nepřenosná.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">POSTUP PŘI ZTRÁTĚ KARTY</h5>
        <p className="text pb-3 bb-1">
          Odcizení nebo ztrátu Vaší karty ve vlastním zájmu prosím neprodleně nahlaste personálu jedné z našich restaurací,
          na tel. <a href="tel:+420730892286">+420 730 892 286</a> nebo e-mailu <a href="mailto:marketing@lobster-restaurant.cz">marketing@lobster-restaurant.cz</a>.
          Po oznámení ztráty máte právo na vydání nové karty za poplatek 100 Kč.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">ZÁNIK ČLENSTVÍ V PROGRAMU</h5>
        <div className="text pb-3 bb-1 lh-1-6">
          Rádi bychom, abyste výhod programu využívali co nejdéle, musíme však pamatovat i na možnost zániku členství. To může nastat v těchto případech:
          <br/><br/>
          <ul className="ml-3">
            <li className="pb-1">o ukončení členství sami požádáte</li>
            <li className="pb-1">odvoláte souhlas se zpracováním svých osobních údajů nebo souhlas s užitím automatizovaných postupů, postačuje odvolání pouze jednoho ze souhlasů,
              (potom nemůžeme nadále udržovat Váš zákaznický účet)
            </li>
            <li className="pb-1">Váš účet bude dvanáct po sobě jdoucích kalendářních měsíců neaktivní</li>
            <li className="pb-1">členství Vám zanikne i v případě, že jakkoli zneužijete mechanismus věrnostního programu</li>
            <li className="pb-1">ukončení činnosti programu společností Gastroland.</li>
          </ul>
          <br/>
          Zánikem členství Vám zaniká právo na výhody vyplývající z členství v programu a taktéž zaniká právo na uplatnění nasbíraných bodů na Vašem zákaznickém účtu.
          Členství v programu, všechna práva s ním spojená, stejně jako karta samotná jsou nepřevoditelná na jinou osobu.
        </div>
      </div>

      <div>
        <h5 className="mt-3 mb-2">ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ</h5>
        <p className="text pb-3 bb-1">
          Podrobné informace o ochraně osobních údajů společnosti Gastroland naleznete <Link to="/privacy-policy" onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}>zde</Link>.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">OCHRANA OSOBNÍCH ÚDAJŮ</h5>
        <p className="text pb-3 bb-1">
          Každý člen programu uděluje společně s registrací do programu svůj souhlas, aby po dobu trvání jeho členství v programu, nejdéle však do odvolání souhlasu,
          Gastroland zpracovával jeho osobní údaje, a to pro účely vyjádřené v souhlasu, kterými jsou zejména realizace marketingových aktivit v rámci programu,
          vytváření průzkumů, analýz a obchodních statistik ohledně nákupního chování a chování v rámci programu a zasílání obchodních sdělení a pozvánek
          na akce pořádané Gastrolandem (v podmínkách jen jako „souhlas se zpracováním osobních údajů“).
          <br/><br/>
          Souhlas se zpracováním osobních údajů je člen programu oprávněn kdykoli odvolat. Doručením odvolání souhlasu se zpracováním osobních údajů
          pozbude Gastroland oprávnění zpracovávat osobní údaje člena programu pro účely uvedené v souhlasu se zpracováním osobních údajů.
          <br/><br/>
          Po odvolání souhlasu se zpracováním osobních údajů je Gastroland oprávněn nadále zpracovávat osobní údaje člena za účelem plnění práv a povinností
          plynoucích pro člena z členství v programu, a to po dobu tří měsíců od data odvolání souhlasu se zpracováním osobních údajů.
          Pokud člen programu odvolá svůj souhlas se zpracováním osobních údajů, nebude Gastroland nadále členovi programu zasílat informace o stavu jeho členského účtu,
          nároku na finanční bonusy, nároku na odměny a o ostatních výhodách programu.
          <br/><br/>
          Odvolá-li člen programu svůj souhlas se zpracováním osobních údajů nebo omezí-li rozsah zpracování osobních údajů zpracovávaných na základě uděleného souhlasu,
          zaniká tímto jeho účast v programu.
        </p>
      </div>

      <div>
        <h5 className="mt-3 mb-2">ZÁVĚREČNÉ USTANOVENÍ</h5>
        <p className="text pb-3">
          Společnost Gastroland připravila věrnostní program Lobster Friends pro své stálé zákazníky se záměrem jej dlouhodobě rozvíjet. Společnost Gastroland si vyhrazuje právo v odůvodněném případě jednostranně ukončit činnost programu Lobster
          Friends, a to i bez udání důvodů. O ukončení programu budou všichni aktivní členové programu informováni, s uvedením přesného data ukončení programu, emailem zaslaným na e-mailovou adresu uvedenou v registračním formuláři i oznámením na
          webových stránkách programu. Každý člen programu bude moci všechny své nasbírané body uplatnit ve lhůtě tří měsíců od data ukončení programu.
          <br/><br/>
          Všechny dotazy Vám rádi zodpovíme na tel. <a href="tel:+420730892286">+420 730 892 286</a> nebo na e-mailové adrese <a href="mailto:marketing@lobster-restaurant.cz">marketing@lobster-restaurant.cz</a>.
          <br/><br/>
          Tato pravidla programu Lobster Friends jsou platná od 1. 9. 2020.
        </p>
      </div>
    </div>
  )
}